import React from "react";
import { Divider, Typography } from "antd";
import { friendlyNumber } from "../../../utils/calculators";
import PlanCard from "./planCard";
import { FEATURE_PROTECT_DOMAINS } from "../../../utils/constants";

const { Paragraph } = Typography;

const InboundCard = props => {
    const { inboundPlan, ...otherProps } = props;
    if (!inboundPlan) return null;
    const price = inboundPlan.basePrice;
    const feature = inboundPlan.features.find(
        feature =>
            FEATURE_PROTECT_DOMAINS.includes(feature.handle)
    );
    let includedDomains = 0;
    if (feature) {
        includedDomains = feature.value;
    }
    return (
        <PlanCard title={inboundPlan.planName} price={price} {...otherProps}>
            <Divider style={{ margin: "0.5rem 0" }} />
            <Paragraph strong style={{ fontSize: "0.875rem" }}>
                {"Inbound Filtering"}
            </Paragraph>
            <ul style={{ listStyleType: "none", paddingLeft: 0 }}>
                <li>
                    {friendlyNumber(includedDomains)}
                    {" Domains"}
                </li>
            </ul>
        </PlanCard>
    );
};

export default InboundCard;
